import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from '@angular/router';
import { MainService } from '../../../../service/main.service';
declare var $: any
import Swal from 'sweetalert2';

import { session } from '../../../../../../environments/environment.session'
import { CodeValueService } from '../../../service/code-value.service';
import { UtilityService } from '../../../service/utility.service';
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
@Component({
  selector: 'app-utility-field',
  templateUrl: './utility-field.component.html',
  styleUrls: ['./utility-field.component.css']
})
export class UtilityFieldComponent {

  constructor(
    private codeValueService: CodeValueService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    public mainService: MainService,
    private utilityService: UtilityService,
    private utf8EncodingService:Utf8EncodingService,
  ) { }
  erpUser: any;
  b_acct_id: any;
  allFields: any = [];
  allDataTyeps: any = [];
  field: any = {};
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  displayedColumns: any = ['field_id', 'field_business_name', 'field_code', 'action'];
  datasource: any;
  l_term_flag: any = true;

  u_term_flag: any = false;
  create_flag: any = false;
  module_cd: any = null;
  logObj = { component: this.module_cd + '-FIELD' }


  async ngOnInit() {


    this.module_cd = this.utilityService?.configObj?.module_cd;
    console.log(this.module_cd);

    if (!this.module_cd) {
      Swal.fire('INFO', 'FACING ISSUE WHILE NAVIGATING', 'info')
      window.history.back()
      return;
    }

    this.erpUser = this.utf8EncodingService.decodeFromUtf8((session.erpUser));;
    this.b_acct_id = this.erpUser.b_acct_id;
    await this.getAllFields();
  }

  open_update(element: any) {
    this.l_term_flag = false;
    this.u_term_flag = true;
    this.create_flag = false
    this.field = Object.assign({}, element);
    $('.nav-tabs a[href="#tab-3"]').tab('show')
  }

  refresh() {
    this.field = {};
  }
  open_create() {
    this.field = {}
    this.l_term_flag = false;
    this.u_term_flag = false;
    this.create_flag = true;
  }

  async getAllFields() {
    this.spinner.show()
    var obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['domain_code'] = this.module_cd
    var resp = await this.codeValueService.getFields(JSON.stringify(obj));
    if (resp['error'] == false) {
      this.allFields = resp.data;
      this.datasource = new MatTableDataSource(this.allFields)
      this.datasource.paginator = this.paginator;
      this.datasource.sort = this.sort;
      this.spinner.hide();
    } else {
      this.spinner.hide()
      this.snackBar.open("Error while getting  all fields list", 'Error', {
        duration: 5000
      });
    }
  }
  async create() {
    let validate = 0
    let obj: any = new Object();
    obj['field_code'] = this.field['field_code']
    obj['field_business_name'] = this.field['field_business_name']
    obj['field_technical_name'] = this.field['field_technical_name']
    obj['field_logical_id'] = 0;
    obj['b_acct_id'] = this.b_acct_id;
    obj['is_code_value_present'] = 1;
    obj['is_code_values_present'] = 0;
    obj['domain_code'] = this.module_cd;
    obj['is_hierarchy_present'] = 0;

    obj['datatype_code'] = 'COMP'
    if (this.field['field_business_name'] && this.field['field_technical_name'] && this.field['field_code']) {
      validate = 1
    }
    if (validate == 1) {
      this.spinner.show();

      var resp = await this.codeValueService.createField(obj);
      if (resp['error'] == false) {
        this.spinner.hide();
        // await this.getAllFields()
        await this.gotolist()
        this.snackBar.open("Field Added Successfully!", 'Success', {
          duration: 5000
        });
      } else {
        this.spinner.hide();
        this.snackBar.open("Error while Adding Field", 'Error', {
          duration: 5000
        });
      }
    } else {
      Swal.fire('Warning...', 'Please Enter All Details Marked As *', 'warning')
    }

  }

  async update() {
    let obj: any = {}
    let validate = 0
    obj = Object.assign({}, this.field)
    obj['update_user_id'] = this.erpUser.user_id;
    obj['b_acct_id'] = this.b_acct_id;
    if (this.field['field_business_name']) {
      validate = 1
    }
    if (validate == 1) {
      this.spinner.show();
      var resp = await this.codeValueService.updateFields(obj);
      if (resp['error'] == false) {
        this.spinner.hide();
        await this.getAllFields();
        this.snackBar.open("Field Update Successfully!", 'Success', {
          duration: 5000
        });
        this.gotolist();
      } else {
        this.spinner.hide();
        this.snackBar.open("Error while updating Field", 'Error', {
          duration: 5000
        });
      }
    } else {
      Swal.fire('Warning...', 'Please Enter All Details Marked As *', 'warning')
    }

  }

  applyFilter(filterValue: string) {
    this.datasource.filter = filterValue.trim().toLowerCase();
  }

  async delete(element: any) {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete'
    }).then((result) => {
      if (result.value) {
        this.finaldelete(element)
      }
    })
  }
  async gotolist() {
    this.l_term_flag = true;

    this.u_term_flag = false;
    this.create_flag = false;
    await this.getAllFields();

  }
  async finaldelete(e: any) {
    this.spinner.show();
    let obj: any = {}
    obj['b_acct_id'] = this.b_acct_id
    obj['field_code'] = e['field_code']
    var resp = await this.codeValueService.deleteFields(obj);
    if (resp['error'] == false) {
      this.spinner.hide();
      await this.getAllFields();
      this.snackBar.open("Field Deleted Successfully!", 'Success', {
        duration: 5000
      });

    } else {
      this.spinner.hide();
      this.snackBar.open("Error while deleting Field", 'Error', {
        duration: 5000
      });
    }
  }
  async save() {
    this.spinner.show();
    this.field['field_logical_id'] = 0;
    this.field['b_acct_id'] = this.b_acct_id;
    this.field['datatype_code'] = 'DTY1'
    this.field['is_code_value_present'] = 1;
    this.field['is_code_values_present'] = 0;
    this.field['is_hierarchy_present'] = 0;
    this.field['domain_code'] = this.module_cd;
    this.field['create_user_id'] = this.erpUser.user_id;
    this.field['b_acct_id'] = this.b_acct_id;
    var resp = await this.codeValueService.createField(this.field);
    if (resp['error'] == false) {
      this.spinner.hide();
      await this.gotolist();
      Swal.fire('Success', " Field Added Successfully!", 'success')
      // this.snackBar.open("Field Added Successfully!", 'Success', {
      //   duration: 5000
      // });
      this.field = {}
    } else {
      this.spinner.hide();
      Swal.fire('Error', 'Error while Adding Field ', 'error')
      // this.snackBar.open("Error while Adding Field", 'Error', {
      //   duration: 5000
      // });
    }
  }

}

